import React, { useState } from "react";
import { Container, Navbar, Nav, Button, Modal, Badge } from "react-bootstrap";
import { checkHealth } from "../../services/apiService";

export default function Layout({ children }) {
  const [healthLoading, setHealthLoading] = useState(false);
  const [healthResult, setHealthResult] = useState(null);
  const [healthError, setHealthError] = useState("");
  const [showHealthModal, setShowHealthModal] = useState(false);

  const handleCheckHealth = async () => {
    setHealthError("");
    setHealthResult(null);

    try {
      setHealthLoading(true);
      const data = await checkHealth();
      setHealthResult(data);
    } catch (err) {
      const msg = err?.response?.data
        ? JSON.stringify(err.response.data, null, 2)
        : err?.message || "เช็คระบบไม่สำเร็จ";
      setHealthError(msg);
    } finally {
      setHealthLoading(false);
      setShowHealthModal(true);
    }
  };

  return (
    <div className="min-vh-100 bg-light">
      <Navbar bg="dark" variant="dark" className="shadow-sm">
        <Container>
          <Navbar.Brand href="/seven-knight/redeem">7K Coupon</Navbar.Brand>

          <Nav className="ms-auto d-flex align-items-center gap-2">
            (
                <Button
                  variant="link"
                  className="p-0 text-light text-decoration-none"
                  style={{ opacity: 0.75 }}
                  onClick={handleCheckHealth}
                  disabled={healthLoading}
                  aria-label="Health check"
                  title="Health check"
                >
                  <span className="ms-auto d-flex align-items-center gap-2">Health check</span>
                </Button>
            )
          </Nav>
        </Container>
      </Navbar>

      <Container className="py-4">{children}</Container>

      {/* Modal แสดงผล Health แบบอ่านง่าย */}
      <Modal show={showHealthModal} onHide={() => setShowHealthModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            Health Check{" "}
            {healthError ? <Badge bg="danger">ERROR</Badge> : <Badge bg="success">OK</Badge>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre className="mb-0 p-3 bg-light rounded small" style={{ maxHeight: 420, overflow: "auto" }}>
            {healthError
              ? healthError
              : JSON.stringify(healthResult ?? { message: "No data" }, null, 2)}
          </pre>
        </Modal.Body>
      </Modal>
    </div>
  );
}
